exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wz-report-tabs[data-v-4999bfd4]{position:fixed;top:36px;margin:auto;z-index:100}", ""]);

// exports
